import React from 'react';

import { SettingsGroup } from '@eluve/blocks';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  Separator,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { InterfaceLanguageSettings } from './InterfaceLanguageSettings';
import { TenantLogoSettings } from './TenantLogoSettings';
import { TenantNameSettings } from './TenantNameSettings';

export const GeneralTenantSettings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SettingsGroup title={t('tenantAdmin.general.title')}>
      <Field orientation="horizontal" className="px-6 py-7">
        <FieldLabel className="whitespace-nowrap">
          {t('tenantAdmin.general.logoLabel')}
        </FieldLabel>
        <div className="flex w-full max-w-60 justify-end">
          <TenantLogoSettings />
        </div>
      </Field>
      <Separator className="my-0" />
      <Field orientation="horizontal" className="px-6 py-5">
        <FieldLabel className="whitespace-nowrap">
          {t('tenantAdmin.general.organizationNameLabel')}
        </FieldLabel>
        <div className="flex w-full max-w-60 justify-end">
          <TenantNameSettings />
        </div>
      </Field>
      <Separator className="my-0" />
      <Field orientation="horizontal" className="px-6 py-5">
        <FieldContent>
          <FieldLabel>
            {t('tenantAdmin.general.interfaceLanguageLabel')}
          </FieldLabel>
          <FieldDescription className="text-balance">
            {t('tenantAdmin.general.interfaceLanguageDescription')}
          </FieldDescription>
        </FieldContent>
        <div className="flex w-full max-w-60 justify-end">
          <InterfaceLanguageSettings />
        </div>
      </Field>
    </SettingsGroup>
  );
};
